/**
 * The customer identity that rides on the Brahma payload (`payload.email` /
 * `payload.name`). Brahma's tools look orders and customer records up by email,
 * so this is what gives a run a customer to act on.
 */

import { Field, FieldInput } from '../ui/field';

export interface CustomerDetails {
  email: string;
  name: string;
}

interface CustomerDetailsFormProps {
  value: CustomerDetails;
  onChange: (value: CustomerDetails) => void;
}

export const CustomerDetailsForm = ({ value, onChange }: CustomerDetailsFormProps) => (
  <div className='grid grid-cols-2 gap-2.5'>
    <Field label='Name'>
      <FieldInput value={value.name} onChange={(e) => onChange({ ...value, name: e.target.value })} placeholder='Jane Doe' />
    </Field>
    <Field label='Email'>
      <FieldInput
        type='email'
        value={value.email}
        onChange={(e) => onChange({ ...value, email: e.target.value })}
        placeholder='jane@example.com'
      />
    </Field>
  </div>
);
